import { Toast } from "shared-ui/src/components/Toast";

/**
 * Success toast for removing a single cart line. Shared by every surface that can
 * remove an item (cart page, mini cart, cart dialogs) so the copy stays identical
 * everywhere.
 */
export function showProductRemovedToast(productName?: string | null) {
  Toast(
    productName
      ? `Product ${productName} removed from cart successfully`
      : "Product removed from cart successfully",
  );
}
